import clsx from "clsx";
import './radio-button.scss';

const RadioButton = ({className, classNameInput, label, name, value, checked, disabled, onChange}) => {
    const handleOnChange = (e) => {
        const { name, value, checked } = e.target
        if (onChange) onChange({ name, value, checked })
    }

    return (
        <div className={clsx('avo__radio__button', className)}>
            <input
                className={clsx('input-radio-button', classNameInput)}
                type={'radio'}
                id={`${name}-${label}`}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={handleOnChange}
            />
            <label className={clsx((checked && !disabled) && 'checked-label', disabled && 'disabled')} htmlFor={`${name}-${label}`}>{label}</label>
        </div>
    )
}

export default RadioButton
